<!-- fileInput.value = null is used when re-select the same file to be uploaded -->
<input
  #fileInput
  type="file"
  accept="*"
  style="display: none"
  (click)="fileInput.value = null"
  (change)="changeFileInput()"
  multiple="true"
/>
<button
  class="btn btn-sm btn-default-orange"
  [ngClass]="{ 'btn-default-orange': isColored, 'btn-control': !isColored }"
  *ngIf="!app.auth.hasMTUPermission"
  (click)="fileInput.click()"
  [ngbTooltip]="app.attachments.uploadTooltip"
>
  <i class="fa fa-upload"></i>
</button>

<!-- open a warning modal is the current user has MTU role -->
<button
  class="btn btn-sm btn-default-orange"
  *ngIf="app.auth.hasMTUPermission"
  (click)="OMWarningModal.open()"
  [ngbTooltip]="app.attachments.uploadTooltip"
>
  <i class="fa fa-upload"></i>
</button>

<app-modal
  #OMWarningModal
  [modalMessage]="app.text.attachments.OMWarning"
  [modalTitle]="app.text.thread.modalTitle"
  [showOMWarning]="true"
  (ok)="fileInput.click()"
>
</app-modal>
